import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import Home from "./pages/index";
import routes from "./routes";
import "./i18n";

export default function App() {
  const location = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
    if (location.hash == "") {
      document.documentElement.scrollTop = 0;
      if (document.scrollingElement) {
        document.scrollingElement.scrollTop = 0;
      }
    } else {
      let id = location.hash.replace("#", "");
      let element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location]);

  type Route = {
    route: string;
    component: React.ReactNode;
  };

  const getRoutes = (
    allRoutes: Route[],
  ): (React.ReactNode | React.ReactNode[])[] =>
    allRoutes.map((route) => {
      if (route.route) {
        return <Route path={route.route} element={route.component} />;
      }
      return null;
    });

  return (
    <Routes>
      {getRoutes(routes)}
      <Route index element={<Home />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
